import React from 'react'

import type { SimpleTitleContentBlock } from '@library/api-menu-experience'
import { SimpleTitle } from '@library/menu-page'

type SimpleTitleContentBlockWrapperProps = {
  contentBlock: SimpleTitleContentBlock
}

export const SimpleTitleContentBlockWrapper = ({
  contentBlock,
}: SimpleTitleContentBlockWrapperProps) => <SimpleTitle contentBlock={contentBlock} />
